import { useStore } from "react-redux"
import React, { useEffect, useRef, useState } from 'react'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { Loader } from 'rsuite';
import { BsCheckSquare, BsFillTelephoneOutboundFill, BsXSquare } from 'react-icons/bs'
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useDispatch } from 'react-redux';
// import { checkEmployerIdNumberExists } from '../../redux/actions/vendor';
import { MdOutlineChangeCircle } from 'react-icons/md';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { RiFileCopyLine } from 'react-icons/ri';
import { checkIsEmailValid, checkIsPhoneNumberValid, checkZip, convertAddress, getAbbreviatedState, getParsedAddress } from "../../../../services/helper";
import { toast } from "../../../CommonComponents/ToastComponent/toast";
import { addSupplierHistory, createChildSupplier } from "../../../../redux/actions/vendor";
import LoaderComponent from "../../../CommonComponents/LoaderComponent";
import { parseFullAddress } from "../../../../redux/actions/upload";
import AllContacts from "../../../ContactsComponent/allContacts";
import { getContacts, getExistingContacts } from "../../../../redux/actions/contact";
import ModalComponent from "../../../CommonComponents/Modal";
import CreateContact from "../../../ContactsComponent/createContact";
import ContactView from "../../../ContactsComponent/contactView";

const CreateChildVendorFromMaster = ({ masterSupplierData = {}, isFromCalls = false, listSupplierId = null, locationMasterData = null, onClose, vendorInCallDetailsId = null, contacts = [], isMasterType = false }) => {
    const dispatch = useDispatch()
    const store = useStore().getState()
    const {
        app: {
            createSupplierBasicColumns
        },
        vendor: {
            masterSupplierDetails,
        },
        auth: { user }
    } = store

    const [masterSupplierInfo, setMasterSupplierInfo] = useState({})
    const [basicInfo, setBasicInfo] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [isNaicsValid, setIsNaicsValid] = useState(false)
    const [isSicValid, setIsSicValid] = useState(false)
    const [isPhoneValid, setIsPhoneValid] = useState(false)
    const [isEmailValid, setIsEmailValid] = useState(false)
    const [isEmailRisky, setIsEmailRisky] = useState(false)
    const [isValidatingEmail, setIsValidatingEmail] = useState(false)
    const [isValidatingPhone, setIsValidatingPhone] = useState(false)
    const [countryCode, setCountryCode] = useState(null)
    const [isParsingAddress, setIsParsingAddress] = useState(false)
    const [showAllContacts, setShowAllContacts] = useState({
        email: false,
        phone: false
    })
    const [existedContacts, setExistedContacts] = useState([])
    const [isLoadingExistingContacts, setIsLoadingExistingContacts] = useState(false)
    const [currentContact, setCurrentContact] = useState({})
    const [showAddNewContact, setShowAddNewContact] = useState(false)
    const [contactDataFromField, setContactDataFromField] = useState({})
    const [allContacts, setAllContacts] = useState([])
    const [isGetContactsData, setIsGetContactsData] = useState(false)

    useEffect(() => {
        if (masterSupplierData && Object.keys(masterSupplierData)?.length) {
            const tmpMasterData = {}
            createSupplierBasicColumns?.map(col => {
                if (col.name === 'phone') {
                    const tmpValue = masterSupplierData?.[col.name]?.hasOwnProperty('value') ? masterSupplierData?.[col.name]?.value || '' : masterSupplierData?.[col.name] || ''
                    const phone = tmpValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && /^\d+$/.test(tmpValue) ? contacts?.find(data => data?.id === parseInt(tmpValue))?.phone : (tmpValue || '')
                    tmpMasterData[col.name] = phone || ''
                    tmpMasterData.phoneContactId = tmpValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && /^\d+$/.test(tmpValue) ? contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
                } else if (col.name === 'email') {
                    const tmpValue = masterSupplierData?.[col.name]?.hasOwnProperty('value') ? masterSupplierData?.[col.name]?.value || '' : masterSupplierData?.[col.name] || ''
                    const email = tmpValue && /^\d+$/.test(tmpValue) ? contacts?.find(data => data?.id === parseInt(tmpValue))?.email : (tmpValue || '')
                    tmpMasterData[col.name] = email || ''
                    tmpMasterData.emailContactId = tmpValue && /^\d+$/.test(tmpValue) ? contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
                } else {
                    tmpMasterData[col.name] = masterSupplierData?.[col.name]?.hasOwnProperty('value') ? masterSupplierData?.[col.name]?.value : masterSupplierData?.[col.name]
                }
            })
            tmpMasterData.id = masterSupplierData?.id?.hasOwnProperty('value') ? masterSupplierData?.id?.value : masterSupplierData?.id
            setMasterSupplierInfo(tmpMasterData)
        } else {
            setMasterSupplierInfo({})
        }
        if (contacts && contacts?.length > 0) {
            setAllContacts(contacts)
        }
    }, [masterSupplierData, contacts])

    useEffect(() => {
        // if (masterSupplierDetails?.contacts && masterSupplierDetails?.contacts?.length > 0) {
        //     setAllContacts(masterSupplierDetails?.contacts)
        // }
    }, [])

    const handleChange = (colName, value, event) => {
        let tmpValue = value
        if (colName === 'state' || colName === 'country') {
            if (/^[a-zA-Z\s]+$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^[a-zA-Z\s]+/gi) ? value.match(/^[a-zA-Z\s]+/gi)[0] : ''
            }
        } else if (colName === 'phone') {
            tmpValue = value
            setIsPhoneValid(false)
        } else if (colName === 'zip') {
            if (/^\d{5}(-\d{4})?$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{1,5}(-\d{0,4})?/gi) ? value.match(/^\d{1,5}(-\d{0,4})?/gi)[0] : ''
            }
        } else if (colName === 'naics') {
            tmpValue = value
            if (value === '' || /^(\d{5}|\d{6})?$/i.test(value)) {
                setIsNaicsValid(true)
            } else {
                setIsNaicsValid(false)
            }
        } else if (colName === 'sic') {
            tmpValue = value
            if (value === '' || /^\d{4}?$/i.test(value)) {
                setIsSicValid(true)
            } else {
                setIsSicValid(false)
            }
        } else if (colName === 'email') {
            if (!tmpValue) {
                setIsEmailValid(true)
            } else {
                setIsEmailValid(false)
            }
        } else if (colName === 'phoneExtension') {
            if (/^\d{20}$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{1,20}/gi) ? value.match(/^\d{1,20}/gi)[0] : ''
            }
        } else if (colName === 'employerIdNumber') {
            if (value.length === 3 && value.includes('-')) {
                value = value?.replaceAll('-', '')
            } else if (value.length === 2 || value.length === 3) {
                if (value.length === 3) {
                    value = value?.substring(0, 2) + '-' + value?.substring(2)
                } else {
                    value += '-'
                }
            }
            if (/^\d{2}(-\d{7})?$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{1,2}(-\d{0,7})?/gi) ? value.match(/^\d{1,2}(-\d{0,7})?/gi)[0] : ''
            }
        } else if (colName === 'abbreviatedState') {
            let regex = /^[a-zA-Z\s]{2}$/
            let regex1 = /^[a-zA-Z\s]{1,2}/gi
            if (basicInfo?.country && (basicInfo?.country.trim().toLowerCase() === 'australia' || basicInfo?.country.trim().toLowerCase() === 'aus')) {
                regex = /^[a-zA-Z\s]{3}$/
                regex1 = /^[a-zA-Z\s]{1,3}/gi
            }
            if (regex.test(value)) {
                tmpValue = value.trim().toUpperCase()
            } else {
                tmpValue = value.trim().match(regex1) ? value.trim().match(regex1)[0].toUpperCase() : ''
            }
        }

        setBasicInfo({
            ...basicInfo,
            [colName]: tmpValue,
        })
    }

    const handlePhoneInputChange = (value, country, e, formattedValue) => {
        var phoneValue = formattedValue?.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '')?.replace(/[^\w\s]|[\s]/gi, '')
        var countrycode = country.dialCode + ' '
        if (phoneValue !== '') {
            phoneValue = countrycode + phoneValue
            setIsPhoneValid('')
        } else {
            phoneValue = country.dialCode
            setIsPhoneValid(true)
        }
        if (e.target === null) {
            handlePhoneNumberFocusOut(e, country, formattedValue)
        }
        setCountryCode(country.dialCode)
        setBasicInfo({
            ...basicInfo,
            'phone': phoneValue === '' ? '' : phoneValue
        })
    }

    const handlePhoneNumberFocusOut = async (event, country, phoneValue) => {
        var countryCode = country && country.dialCode
        var phoneValueWithCode = phoneValue
        var testPhone = phoneValue?.toString()?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '')?.replace(/[^\w\s]|[\s]/gi, '')
        if (testPhone && testPhone !== '' && testPhone !== countryCode && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i?.test(testPhone)) {
            setIsPhoneValid(false)
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            return
        }

        if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode?.toString()?.replace(/^\s*(?:\+)/, ''))) {
            return
        }
        if (phoneValue !== '') {
            setIsValidatingPhone(true)
            phoneValue = phoneValue?.toString()?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '')?.replace(/[^\w\s]|[\s]/gi, '')
            var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
            setIsPhoneValid(phoneValidationResult?.isPhoneValid)
            setIsValidatingPhone(phoneValidationResult?.isValidatingPhone)
        } else {
            setIsPhoneValid(true)
        }
    }

    const handleEmailFocusOut = async (emailValue, isRetry = false) => {
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            setIsEmailValid(false)
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!'
            })
            return
        }
        if (emailValue && emailValue !== '') {
            setIsValidatingEmail(true)
            var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
            setIsEmailValid(emailValidationResult?.isEmailValid)
            setIsValidatingEmail(emailValidationResult?.isValidatingEmail)
            setIsEmailRisky(emailValidationResult?.isEmailRisky)
        } else {
            setIsEmailValid(true)
        }
    }

    const onCopyHandler = (value, col) => {
        if (value === "") {
            return;
        }

        if (col.name === 'naics') {
            if (value === '' || /^(\d{5}|\d{6})?$/i.test(value)) {
                setIsNaicsValid(true)
            } else {
                setIsNaicsValid(false)
            }
        }
        if (col.name === 'sic') {
            if (value === '' || /^\d{4}?$/i.test(value)) {
                setIsSicValid(true)
            } else {
                setIsSicValid(false)
            }
        }

        if (col.name === 'phone') {
            setBasicInfo(prevState => {
                return {
                    ...prevState,
                    [col.name]: value,
                    phoneExtension: masterSupplierInfo?.phoneExtension,
                    phoneContactId: masterSupplierInfo?.phoneContactId || null
                }
            })
            handlePhoneNumberFocusOut(null, null, value)
        } else {
            if (col.name === 'email') {
                handleEmailFocusOut(value)
            }
            setBasicInfo(prevState => {
                return {
                    ...prevState,
                    [col.name]: value,
                    emailContactId: masterSupplierInfo?.emailContactId || null
                }
            })
        }
    }

    const onCopyClick = () => {
        const supInfo = { ...basicInfo, ...masterSupplierInfo }
        const tmpSupInfo = { ...supInfo }
        delete tmpSupInfo['id']
        delete tmpSupInfo['isMaster']
        if (tmpSupInfo?.naics === '' || !tmpSupInfo?.naics || /^(\d{5}|\d{6})?$/i.test(tmpSupInfo?.naics)) {
            setIsNaicsValid(true)
        } else {
            setIsNaicsValid(false)
        }

        if (tmpSupInfo?.sic === '' || !tmpSupInfo?.sic || /^\d{4}?$/i.test(tmpSupInfo?.sic)) {
            setIsSicValid(true)
        } else {
            setIsSicValid(false)
        }
        handleEmailFocusOut(tmpSupInfo?.['email'])
        handlePhoneNumberFocusOut(null, null, tmpSupInfo?.['phone'])
        setBasicInfo(tmpSupInfo)
    }

    const handleSave = async () => {
        if (countryCode === basicInfo?.phone) {
            basicInfo['phone'] = ''
        }

        if (!basicInfo?.suppliername) {
            toast.show({
                title: 'Warning',
                description: 'Supplier Name shouldn\'t be empty!',
            })
            return
        }

        if (basicInfo?.address1?.value) {
            let address = convertAddress(basicInfo?.address1?.value)
            basicInfo.address1 = { label: address, value: address }
        }

        if (basicInfo?.zip) {
            let validZip = checkZip(basicInfo?.zip)
            if (!validZip) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid Zip',
                })
                return
            }
        }

        if (isValidatingPhone) {
            toast.show({
                title: 'Warning',
                description: 'validating phone number...!',
            })
            return
        }
        if (isValidatingEmail) {
            toast.show({
                title: 'Warning',
                description: 'validating email...!',
            })
            return
        }
        if (basicInfo?.email && !isEmailValid && isEmailValid !== '') {
            toast.show({
                title: 'Warning',
                description: 'Invalid Email'
            })
            return
        }
        if (basicInfo?.phone && isPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Phone Number.'
            })
            return
        }
        if (basicInfo?.naics && !isNaicsValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid NAICS Code. Must be atleast 5 or 6 digits long.'
            })
            return
        }
        if (basicInfo?.sic && !isSicValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid SIC Code. Must be atleast 4 digits long.'
            })
            return
        }

        if (basicInfo?.state && !basicInfo?.abbreviatedState) {
            let stateCode = getAbbreviatedState(basicInfo?.abbreviatedState, basicInfo?.state)
            basicInfo['abbreviatedState'] = stateCode
        }

        if (basicInfo?.abbreviatedState && basicInfo?.abbreviatedState !== '') {
            let regex = /^[a-zA-Z\s]{2}$/
            let stateChars = 2
            if (basicInfo?.country && (basicInfo?.country.trim().toLowerCase() === 'australia' || basicInfo?.country.trim().toLowerCase() === 'aus')) {
                regex = /^[a-zA-Z\s]{2,3}$/
                stateChars = '2 or 3'
            }
            if (!regex.test(basicInfo?.abbreviatedState.trim())) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid State. Must be ' + stateChars + ' characters long!'
                })
                return
            }
        }

        let tmpData = { ...basicInfo }
        if (masterSupplierInfo?.id) {
            tmpData.masterId = masterSupplierInfo?.id
        }

        if (isFromCalls && listSupplierId && !masterSupplierInfo?.id) {
            tmpData.listSupplierId = listSupplierId
            tmpData.isInCalls = true
        }

        if (isFromCalls && vendorInCallDetailsId && !masterSupplierInfo?.id && !listSupplierId) {
            tmpData.vendorInCallsDetailsId = vendorInCallDetailsId
            tmpData.isInCalls = true
        }

        if (locationMasterData) {
            tmpData.primaryMasterId = locationMasterData?.masterId
        }

        setIsLoading(true)
        dispatch(
            createChildSupplier({
                basicData: tmpData,
                cardData: {},
                paymentData: {},
                feeData: [],
                isCreatedInSequence: isFromCalls
            })
        ).then(async (res) => {
            await addChildSupplierHistory(res?.supplier?.id, res?.supplier?.suppliername)
            onClose(true, isGetContactsData, res?.supplier?.id)
            setIsLoading(false)
        }).catch(() => {
            setIsLoading(false)
        })
    }

    const addChildSupplierHistory = async (supId, supName) => {
        var note = 'Child Supplier created';
        if (masterSupplierInfo?.id && !locationMasterData) {
            note += ' and assigned to Master ' + '<a target="_blank" href="/suppliers/' + masterSupplierInfo?.id + '"><b>' + masterSupplierInfo?.suppliername + '</b></a> by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>'
        } else if (masterSupplierInfo?.id && locationMasterData) {
            note += ' and assigned to Master ' + '<a target="_blank" href="/suppliers/relatedsupplier/' + masterSupplierInfo?.id + '"><b>' + masterSupplierInfo?.suppliername + '</b></a> by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>'
        } else {
            note += ' by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>'
        }
        if (note !== '') {
            await dispatch(
                addSupplierHistory({
                    supplierId: isMasterType ? masterSupplierInfo?.id : supId,
                    note: note,
                    noteType: 'changelog',
                    listSupplierId: listSupplierId,
                    isInCalls: isFromCalls
                })
            )
            if (masterSupplierInfo?.id) {
                var masterNote = 'Child supplier ' + '<a target="_blank" href="/suppliers/relatedsupplier/' + supId + '"><b>' + supName + '</b></a> for master created by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>'
                await dispatch(
                    addSupplierHistory({
                        supplierId: masterSupplierInfo?.id,
                        note: masterNote,
                        noteType: 'changelog',
                        listSupplierId: listSupplierId,
                        isInCalls: isFromCalls
                    })
                )
            }
        }
    }

    const parseAddress = async () => {
        if (basicInfo?.address1) {
            try {
                setIsParsingAddress(true)
                const addressResult = await dispatch(parseFullAddress(basicInfo?.address1))
                setIsParsingAddress(false)
                const parsedResult = getParsedAddress(addressResult)
                setBasicInfo({
                    ...basicInfo,
                    'address1': parsedResult?.add1 ? parsedResult?.add1 : '',
                    'address2': parsedResult?.add2 ? parsedResult?.add2 : '',
                    'city': parsedResult?.city ? parsedResult?.city?.value : '',
                    'state': parsedResult?.state ? parsedResult?.state?.value : '',
                    'abbreviatedState': parsedResult?.state ? parsedResult?.state?.value : '',
                    'country': parsedResult?.country ? parsedResult?.country?.value : '',
                    'zip': parsedResult?.zip ? parsedResult?.zip?.value : ''
                })
            } catch (err) {
                setIsParsingAddress(false)
            }
        }
    }

    const onContactMouseHover = (event) => {
        const parentWithClass = event.target.closest('.phone-input-parent')
        if (event.target?.dataset?.contactId) {
            const contact = allContacts?.find(data => data?.id === parseInt(event.target?.dataset?.contactId))
            setCurrentContact(contact ? contact : {})
        } else {
            setCurrentContact({})
        }
        if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
            parentWithClass.nextSibling.style.display = 'block'
        } else if (event.target && event.target?.nextSibling && event.target?.nextSibling?.classList?.value?.includes('contact-view')) {
            event.target.nextSibling.style.display = 'block'
        }
    }

    const onContactMouseHoverOut = (event) => {
        const parentWithClass = event.target.closest('.phone-input-parent')
        if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
            parentWithClass.nextSibling.style.display = 'none'
        } else if (event.target && event.target?.nextSibling && event.target?.nextSibling.classList?.value?.includes('contact-view')) {
            event.target.nextSibling.style.display = 'none'
        }
        setCurrentContact({})
    }

    const onPhoneEmailClick = (type1, type2) => {
        setShowAllContacts({ ...showAllContacts, [type1]: !showAllContacts?.[type1], [type2]: false })
        setExistedContacts(allContacts)
        // setExistedContacts(masterSupplierDetails?.contacts)
    }

    const onPhoneEmailFocusOutClick = () => {
        setShowAllContacts({ ...showAllContacts, email: false, phone: false })
        setExistedContacts(allContacts)
        // setExistedContacts(masterSupplierDetails?.contacts)
    }

    useEffect(() => {
        if (showAllContacts?.phone && basicInfo?.phone?.trim() && basicInfo?.phone?.trim()?.length >= 4) {
            setIsLoadingExistingContacts(true)
            const delayDebounceFn = setTimeout(async () => {
                onGetExistingContacts(basicInfo?.phone?.trim(), 'phone')
            }, 1000)

            return () => clearTimeout(delayDebounceFn)
        }
    }, [basicInfo?.phone])

    useEffect(() => {
        if (showAllContacts?.email && basicInfo?.email?.trim() && basicInfo?.email?.trim()?.length >= 4) {
            setIsLoadingExistingContacts(true)
            const delayDebounceFn = setTimeout(async () => {
                onGetExistingContacts(basicInfo?.email?.trim(), 'email')
            }, 1000)

            return () => clearTimeout(delayDebounceFn)
        }
    }, [basicInfo?.email])

    const onGetExistingContacts = (searchValue, type = '') => {
        try {
            setIsLoadingExistingContacts(true)
            dispatch(getExistingContacts({ searchValue, type })).then((res) => {
                if (res?.contacts && res?.contacts?.length > 0) {
                    setExistedContacts(res?.contacts)
                } else {
                    setExistedContacts([])
                }
                setIsLoadingExistingContacts(false)
            }).catch(() => {
                setExistedContacts([])
                setIsLoadingExistingContacts(false)
            })
        } catch (err) {
            setExistedContacts([])
            setIsLoadingExistingContacts(false)
        }
    }

    const handleContactClick = async (rowData) => {
        const tmpData = { ...basicInfo }
        if (showAllContacts?.phone) {
            if (!rowData?.phone) {
                toast.show({
                    title: 'Warning',
                    description: 'No phone number is assigned to this contact!'
                })
                return
            }
            tmpData.phone = rowData?.phone || ''
            tmpData.phoneContactId = rowData?.id || null
            await handlePhoneNumberFocusOut(null, null, tmpData.phone)
        }
        if (showAllContacts?.email) {
            if (!rowData?.email) {
                toast.show({
                    title: 'Warning',
                    description: 'No email is assigned to this contact!'
                })
                return
            }
            tmpData.email = rowData?.email || ''
            tmpData.emailContactId = rowData?.id || null
            await handleEmailFocusOut(tmpData.email)
        }
        setBasicInfo(tmpData)
        onPhoneEmailFocusOutClick()
        if (rowData) {
            const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
            const index = tmpContacts?.findIndex(data => data?.id === rowData?.id)
            if (index === -1) {
                tmpContacts.push(rowData)
            }
            setAllContacts(tmpContacts)
            setExistedContacts(tmpContacts)
        }
    }

    const onCreateContact = () => {
        let value = ''
        let colName = ''
        if (showAllContacts?.phone) {
            colName = 'phone'
            value = basicInfo?.phone ? (!/^\s*(?:\+?(\d{1,3})\s)/.test(basicInfo?.phone) ? `1 ${basicInfo?.phone}` : basicInfo?.phone) : ''
        } else {
            colName = 'email'
            value = basicInfo?.email || ''
        }
        setShowAddNewContact(true)
        setContactDataFromField({
            colName,
            value
        })
        onPhoneEmailFocusOutClick()
    }

    const handleCreateContactClose = async (e, isGetContactsData = false, contact = null,) => {
        const contactId = contact?.id || null
        if (contactId) {
            contact.contactName = contact?.firstname + ' ' + contact?.lastname
            const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
            tmpContacts.push(contact)
            if (contactDataFromField?.colName === 'email') {
                setBasicInfo({ ...basicInfo, emailContactId: contactId, email: contact?.email })
                await handleEmailFocusOut(contact?.email)
            } else {
                setBasicInfo({ ...basicInfo, phoneContactId: contactId, phone: contact?.phone })
                await handlePhoneNumberFocusOut(null, null, contact?.phone)
            }
            setAllContacts(tmpContacts)
            setExistedContacts(tmpContacts)
        }

        setContactDataFromField({})
        setShowAddNewContact(false)

        if (isGetContactsData) {
            setIsGetContactsData(true)
            // let supplierIds = [masterSupplierDetails?.baseInfo?.id]
            // if (masterSupplierDetails?.childVendors && masterSupplierDetails?.childVendors?.length > 0) {
            //     const childIds = masterSupplierDetails?.childVendors?.map(sup => sup?.id)
            //     if (childIds && childIds?.length > 0) {
            //         supplierIds = [...supplierIds, ...childIds]
            //     }
            // }
            // if (supplierIds?.length) {
            //     await dispatch(getContacts({ supplierIds }))
            // }
        }
    }

    const onGetContactsData = () => {
        if (showAllContacts?.email) {
            onGetExistingContacts(basicInfo?.email?.trim(), 'email')
        }
        if (showAllContacts?.phone) {
            onGetExistingContacts(basicInfo?.phone?.trim(), 'phone')
        }
    }

    const handleRemoveContact = (colName) => {
        if (colName === 'email') {
            setBasicInfo({ ...basicInfo, emailContactId: null, email: '' })
            setIsEmailValid(true)
        } else {
            setBasicInfo({ ...basicInfo, phoneContactId: null, phone: '' })
            setIsPhoneValid(true)
        }
    }

    return (
        <>
            <div className='assign-vendor-supply position-relative'>
                <div className={`create-master-modal p-0 border-0 position-relative mt-0${isLoading ? ' loading' : ''}`}>
                    {isLoading && <LoaderComponent />}
                    <div className="card m-0 content">
                        <div className="sticky-header bg-white new-master-supplier-tabs-header px-4">
                            <div className="tab-header flex">
                                <div className="first-child"></div>
                                <label className="text-blue"> Master Supplier </label>
                                <label className="text-blue"> Child Supplier </label>
                            </div>
                        </div>
                        <div className='basic-tab'>
                            <div className="card-content ps-5 pe-5 border-0 list main-info">
                                {
                                    createSupplierBasicColumns && createSupplierBasicColumns.length > 0 && createSupplierBasicColumns.map(col => {
                                        if (col.name === 'abbreviatedState') {
                                            return
                                        }
                                        return (
                                            <div key={col.name} className='main-info-child flex align-items-center'>
                                                <h4 className='first-child fw-bold text-black mb-0'>{col.label}:</h4>
                                                {col.name === 'phone' ?
                                                    <>
                                                        <div className="phone-input-parent flex align-center">
                                                            <div className='d-flex border rounded phone-input-ext-container w-100 flex-column flex-lg-row'>
                                                                <ReactPhoneInput
                                                                    className='phone-input-parent'
                                                                    country={'us'}
                                                                    value={masterSupplierInfo?.[col.name] || ''}
                                                                    disabled={true}
                                                                    buttonClass='border-0 border-end'
                                                                    inputProps={{
                                                                        className: 'form-control border-0'
                                                                    }}
                                                                />
                                                                <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                                    <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                                    <input type="text" className="shadow-none w-100 border-0 ps-3 pe-3 h4 mb-0 text-dark" placeholder="phone extension" disabled={true} value={masterSupplierInfo?.['phoneExtension'] || ''} />
                                                                </div>
                                                                <CopyToClipboard text={masterSupplierInfo?.[col.name] || ''}>
                                                                    <button className='input-group-text' onClick={() => { onCopyHandler(masterSupplierInfo?.[col.name], col) }}><RiFileCopyLine size={26} color="rgb(87 171 234)" /></button>
                                                                </CopyToClipboard>
                                                            </div>
                                                        </div>
                                                        <div className="phone-input-parent flex align-center position-relative">
                                                            <div className={`d-flex border rounded phone-input-ext-container w-100 flex-column flex-lg-row${basicInfo?.phoneContactId ? ' input-group' : ''}`}>
                                                                {basicInfo?.phoneContactId && (
                                                                    <span role='button' class='border border-start-0 border-top-0 border-bottom-0 input-group-text text-red px-3 fs-2 fw-bold mb-0' onClick={() => { handleRemoveContact('phone') }}>X</span>
                                                                )}
                                                                <input
                                                                    value={basicInfo[col.name] || ''}
                                                                    className={`search-input border-0 h4 mb-0 text-primary`}
                                                                    onChange={e => handleChange(col.name, e.target.value)}
                                                                    data-contact-id={basicInfo?.phoneContactId || ''}
                                                                    autoComplete='no-phone'
                                                                    onClick={() => { onPhoneEmailClick('phone', 'email') }}
                                                                    onMouseOver={(e) => { onContactMouseHover(e) }}
                                                                    onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                                />
                                                                {basicInfo?.[col.name] && !showAllContacts?.phone && (
                                                                    <ContactView contact={currentContact} />
                                                                )}
                                                                {showAllContacts?.phone && (
                                                                    <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={onCreateContact} supplierId={masterSupplierDetails?.baseInfo?.id} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                                                )}
                                                                <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                                    <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                                    <input
                                                                        type="text"
                                                                        className="shadow-none w-100 border-0 ps-3 pe-3 h4 mb-0 text-dark"
                                                                        placeholder="phone extension"
                                                                        onChange={(newValue) => handleChange('phoneExtension', newValue.target.value)}
                                                                        value={basicInfo?.['phoneExtension'] || ''}
                                                                        disabled={(!basicInfo?.['phone'] || !isPhoneValid || basicInfo?.['phone'] === countryCode) ? true : false}
                                                                    />

                                                                </div>
                                                            </div>
                                                            {isValidatingPhone && (<Loader />)}
                                                            {!isValidatingPhone && isPhoneValid !== '' && basicInfo?.['phone'] &&
                                                                (isPhoneValid ?
                                                                    <BsCheckSquare color="#067911" size={22} />
                                                                    :
                                                                    <BsXSquare color="#f75a52" size={22} />
                                                                )
                                                            }
                                                        </div>
                                                    </>
                                                    :
                                                    col.name === 'email' ?
                                                        <>
                                                            <div className="input-group h-100">
                                                                <input
                                                                    type="text"
                                                                    className="search-input fs-4 mb-0 form-control"
                                                                    value={masterSupplierInfo?.[col.name] || ''}
                                                                    disabled={true}
                                                                />
                                                                <CopyToClipboard text={masterSupplierInfo?.[col.name] || ''}>
                                                                    <button className='input-group-text' onClick={() => { onCopyHandler(masterSupplierInfo?.[col.name], col) }}><RiFileCopyLine size={26} color="rgb(87 171 234)" /></button>
                                                                </CopyToClipboard>
                                                            </div>

                                                            <div className={`phone-input-parent flex align-center position-relative${basicInfo?.emailContactId ? ' input-group h-100 align-items-center' : ''}`}>
                                                                {basicInfo?.emailContactId && (
                                                                    <span role='button' class='border-end-0 input-group-text text-red px-3 fs-2 fw-bold h-100 mb-0' onClick={() => { handleRemoveContact('email') }}>X</span>
                                                                )}
                                                                <input
                                                                    type="text"
                                                                    style={{ marginLeft: basicInfo?.emailContactId ? '-10px' : '0' }}
                                                                    className="search-input h4 mb-0 text-primary"
                                                                    onChange={(newValue) => handleChange(col.name, newValue.target.value)}
                                                                    value={basicInfo?.[col.name] || ''}
                                                                    // onBlur={() => { isEmailValid === '' && handleEmailFocusOut(basicInfo[col.name]) }}
                                                                    onClick={() => { onPhoneEmailClick('email', 'phone') }}
                                                                    onMouseOver={(e) => { onContactMouseHover(e) }}
                                                                    onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                                    autoComplete="no-email"
                                                                    data-contact-id={basicInfo?.emailContactId || ''}
                                                                />
                                                                {basicInfo?.[col.name] && !showAllContacts?.email && (
                                                                    <ContactView contact={currentContact} />
                                                                )}
                                                                {showAllContacts?.email && (
                                                                    <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={onCreateContact} supplierId={masterSupplierDetails?.baseInfo?.id} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                                                )}
                                                                {isValidatingEmail && (<Loader />)}
                                                                {basicInfo?.[col.name] && !isValidatingEmail && isEmailValid !== '' &&
                                                                    (isEmailValid ?
                                                                        <BsCheckSquare color="#067911" size={26} />
                                                                        :
                                                                        <>
                                                                            <BsXSquare color="#f75a52" size={26} />
                                                                            {/* <MdOutlineChangeCircle
                                                                                title='Retry'
                                                                                role='button'
                                                                                color="#14438b"
                                                                                size={30}
                                                                                onClick={() => { handleEmailFocusOut(basicInfo[col.name], true) }}
                                                                            /> */}
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                        </>
                                                        :
                                                        <>

                                                            <div className="input-group h-100 ">
                                                                {/* <div class="d-flex h-100 w-100"> */}
                                                                <input
                                                                    type="text"
                                                                    className=" search-input fs-4 mb-0 form-control"
                                                                    value={masterSupplierInfo?.[col.name] || ''}
                                                                    disabled={true}
                                                                />
                                                                <CopyToClipboard text={masterSupplierInfo?.[col.name] || ''}>
                                                                    <button
                                                                        className='input-group-text'
                                                                        onClick={() => { onCopyHandler(masterSupplierInfo?.[col.name], col) }}
                                                                    ><RiFileCopyLine size={26} color="rgb(87 171 234)" /></button>
                                                                </CopyToClipboard>
                                                                {/* </div> */}
                                                            </div>
                                                            <div className="phone-input-parent flex align-center h-100">
                                                                <input
                                                                    type="text"
                                                                    title={basicInfo?.[col.name] || ''}
                                                                    className="search-input h4 mb-0"
                                                                    onChange={(newValue) => handleChange(col.name, newValue.target.value)}
                                                                    value={basicInfo?.[col.name] || ''} />
                                                                {col.name === 'address1' && basicInfo?.address1 && (
                                                                    <div className="position-relative text-center h-100">
                                                                        {isParsingAddress && <Loader size="sm" className="top-33 position-absolute start-0 end-0" />}
                                                                        <button
                                                                            type="button"
                                                                            className={`${isParsingAddress ? 'bg-light ' : ''}h-100 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100 bg-dark-blue rounded text-white`}
                                                                            onClick={parseAddress}
                                                                        >
                                                                            Parse Address
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-4 d-flex gap-3 justify-content-end position-sticky" style={{ bottom: '-30px' }}>
                    <button type="button" disabled={isParsingAddress} className="fs-4 pt-2 pb-2 rounded btn-gray width-100 shadow-none" onClick={() => { onClose(false, isGetContactsData) }}>
                        Cancel
                    </button>
                    <button className='pt-2 pb-2 width-100 rounded h4 mb-0 btn-green' onClick={onCopyClick} disabled={isParsingAddress}> Copy Info</button>
                    <button type="button" className="fs-4 pt-2 pb-2 rounded btn-green width-100 shadow-none" onClick={handleSave} disabled={isParsingAddress || isLoading}>
                        Save
                    </button>
                </div>
            </div>
            {showAddNewContact && (
                <>
                    <ModalComponent size='xl' modalTitle='' open={showAddNewContact} handleClose={handleCreateContactClose} dialogClassName='px-5 create-new-contact-modal-dialog'>
                        <CreateContact onClose={handleCreateContactClose} contactDataFromField={contactDataFromField} />
                    </ModalComponent>
                </>
            )}
        </>
    )
}

export default CreateChildVendorFromMaster